<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body" [style]="enableError? 'margin: 1% 2% 0% 3%;':  'margin: 1% 2% 4.8% 3%;'">
    <br>
    <div class="row">
        <label class="catlabel col-5">From Period</label>
        <label class="label col-5">{{ fromPeriodLabel }}</label>


    </div>
    <div class="row">

        <label class="catlabel col-5">To Period<span style="color:#ff0000">*</span></label>
        <select [(ngModel)]="selected_period_id" [ngModelOptions]="{standalone: true}"
            style="font-family:Roboto;font-size:13px;height: 26px;" class="col-5">
            <option *ngFor="let toPeriod of toPeriodList" [value]="toPeriod.periodId">
                {{toPeriod.period}}
            </option>
        </select>

    </div>

</div>


<label *ngIf="enableError" class="errormsg"> {{errormsg}} </label>
<div class=" footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SAVE</button>
</div>